import {
    createAsyncThunk
} from "@reduxjs/toolkit";
import {getRandomColor} from "../shared_functions";






// network-level failures (connection refused, dropped mid-flight - e.g. a
// service restart window) get ONE retry after a short pause; HTTP errors
// never retry so real problems stay visible immediately
function fetchWithRetry(url, requestOptions) {
    return fetch(url, requestOptions).catch(() =>
        new Promise((resolve) => setTimeout(resolve, 700)).then(() => fetch(url, requestOptions))
    );
}

export function smileConcealAPIcall({ url,requestOptions,userManager }){


    return userManager.getUser().then(user=>{
        if (user){
            if (requestOptions.hasOwnProperty("headers")){
                requestOptions.headers.Authorization =  "Bearer " + user[window._env_.REACT_APP_OIDC_TOKEN]
            }else{
                requestOptions.headers={"Authorization":  "Bearer " + user[window._env_.REACT_APP_OIDC_TOKEN]}
            }
        }

           return fetchWithRetry(url, requestOptions)
                    .then(async data => {

                            if (data.status && data.status>400){
                                // surface HTTP errors instead of swallowing them -
                                // the old chain returned undefined here, which the
                                // next step destructured ("Cannot destructure
                                // property 'status' of '_ref2'")
                                const error = await data.json().catch(() => ({}));
                                console.error(error)
                                throw new Error(error.message || error.error || `HTTP ${data.status} on ${url}`)
                            }

                            return data.json()

                        })
                    .then((result) => {
                        const { status, ...apiData } = result || {};

                        if ( ({...apiData}.hasOwnProperty("error") && {...apiData}.hasOwnProperty("stackTrace"))) {

                            const error = {...apiData};

                           throw Error(JSON.stringify(error))
                        } else {

                            return apiData ;
                        }
                    });



    })
}

export const callJobApi = createAsyncThunk("request/callJobAPI",  async ( {userManager,cmd,id}) => {

    const body ={
        "jobId": id,
        "action": "start"
    }

    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs/${id}/${cmd}`,requestOptions:{method:"POST",headers:{"content-type":"application/json"}},body:JSON.stringify(body),userManager});
    console.log(response)
    return response;
});


export const saveTrainingData = createAsyncThunk("request/saveTrainingData",  async ( {userManager,data}) => {
    const response = await smileConcealAPIcall({url:window._env_.REACT_APP_API_URL+"/saveTrainingData",requestOptions:{method:"POST",headers:{"content-type":"application/json"},userManager,body:JSON.stringify(data)},userManager});

    return response.data;
});
export const getTags = createAsyncThunk("request/getTags",  async ( {userManager,data}) => {
    const response = await smileConcealAPIcall({url:window._env_.REACT_APP_API_URL+"/entities",requestOptions:{method:"POST",headers:{"content-type":"application/json"},userManager,body:JSON.stringify(data)},userManager});

    return response.all_entities;
});

export const getTrainingDataList = createAsyncThunk("request/getTrainingDataList",  async ( {userManager}) => {
    const response = await smileConcealAPIcall({url:window._env_.REACT_APP_API_URL+"/getTrainingData",requestOptions:{method:"GET",headers:{"content-type":"application/json"}},userManager});

    // prefer detailed list (name + modified, newest first); fall back to plain names
    return response.files || response.available_files;
});
export const getTrainingDataFile = createAsyncThunk("request/getTrainingDataFile",  async ( {file,userManager} ) => {
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/getTrainingData/${file}`,requestOptions:{method:"GET",headers:{"content-type":"application/json"}},userManager});

    return response.data;
});

export const getModels = createAsyncThunk("request/getModels",  async ({userManager} ) => {
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/getModels`,requestOptions:{method:"GET",headers:{"content-type":"application/json"}},userManager});
    console.log(response)
    return response.available_models;
});

export const getConfig = createAsyncThunk("request/getConfig",  async ({userManager} ) => {
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/getConfig`,requestOptions:{method:"GET",headers:{"content-type":"application/json"}},userManager});
    console.log(response)
    return response.data;
});

export const saveConfig = createAsyncThunk("request/saveConfig",  async ({config,userManager} ) => {

    const body={
        data:config
    }
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/saveConfig`,requestOptions:{method:"POST",headers:{"content-type":"application/json"},body:JSON.stringify(body)},userManager});

    return response.data;
});
export const createModel = createAsyncThunk("request/createModel",  async ( {modelName,baseModel,filename,language,userManager} ) => {

    const body={
        modelname:modelName,
        basemodel:baseModel,
        filename,
        language
    }
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/createModel`,requestOptions:{method:"POST",headers:{"content-type":"application/json"},body:JSON.stringify(body)},userManager});

    return response.data;
});

export const testModel = createAsyncThunk("request/testModel",  async ( {testString,modeldef,removeTags,dynamicTagging,privacyFilter,llmTagging,entities,userManager,savedConfig} ) => {

    let body;

    if (modeldef.type === "config") {
        // Saved config mode — send full config as-is
        const parsed = JSON.parse(savedConfig);
        body = {
            text: testString,
            removeTags,
            ...parsed
        };
    } else if (modeldef.type === "gliner") {
        // GLiNER-only mode - explicitly disable privacy filter and LLM
        body = {
            text: testString,
            dynamicTagging: dynamicTagging,
            privacyFilter: { model: "" },
            llmTagging: { enabled: false },
            entities: entities,
            configuration: { nlp_engine_name: "spacy", models: [] }
        };
    } else if (modeldef.type === "privacy-filter") {
        // Privacy-filter-only mode - explicitly disable GLiNER, spaCy and LLM
        body = {
            text: testString,
            privacyFilter: privacyFilter,
            dynamicTagging: { model: "" },
            llmTagging: { enabled: false },
            entities: {},
            configuration: { nlp_engine_name: "spacy", models: [] }
        };
    } else if (modeldef.type === "llm") {
        // LLM-only mode - disable all local recognizers. The entities are
        // sent along because they steer the LLM (entity catalog in the prompt).
        body = {
            text: testString,
            llmTagging: { ...(llmTagging || {}), enabled: true },
            dynamicTagging: { model: "" },
            privacyFilter: { model: "" },
            entities: entities,
            configuration: { nlp_engine_name: "spacy", models: [] }
        };
    } else {
        // spaCy mode
        const configuration = {
            nlp_engine_name: "spacy",
            models: [{
                lang_code: modeldef.lang,
                model_name: (modeldef.type === "custom") ? `./models/${modeldef.model}` : modeldef.model
            }]
        };

        if (dynamicTagging && dynamicTagging.model) {
            // Combined mode: spaCy + GLiNER (local recognizers only)
            body = {
                text: testString,
                dynamicTagging: dynamicTagging,
                entities: entities,
                removeTags,
                trainedTagging: {},
                llmTagging: { enabled: false },
                configuration
            };
        } else {
            // spaCy-only mode — explicitly disable GLiNER, privacy filter and LLM,
            // and lift the trainedTagging restriction (this mode tests the model itself).
            // entities must contain the model's tags, otherwise the backend
            // never registers the custom recognizer for them.
            body = {
                text: testString,
                removeTags,
                dynamicTagging: { model: "" },
                privacyFilter: { model: "" },
                llmTagging: { enabled: false },
                trainedTagging: {},
                entities: Object.fromEntries((removeTags || []).map(t => [t, {labels: []}])),
                configuration
            };
        }
    }

    const started = Date.now();
    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/anonymizeText`,requestOptions:{method:"POST",headers:{"content-type":"application/json"},body:(JSON.stringify(body))},userManager});

    return { ...response, durationMs: Date.now() - started };
});

export const getEntities = createAsyncThunk("request/getEntities",  async ( {userManager} ) => {






    const response = await smileConcealAPIcall({url:`${window._env_.REACT_APP_API_URL}/entities`,requestOptions:{method:"POST",headers:{"content-type":"application/json"}},userManager});

    return response.all_entities.map(e=>{
        return {
            "tag":e,
            "color":getRandomColor()
        }
    })

});

// Cockpit API call (supports array responses)
export function cockpitAPIcall({ url, requestOptions, userManager }) {
    return userManager.getUser().then(user => {
        if (user) {
            if (requestOptions.hasOwnProperty("headers")) {
                requestOptions.headers.Authorization = "Bearer " + user[window._env_.REACT_APP_OIDC_TOKEN];
            } else {
                requestOptions.headers = {"Authorization": "Bearer " + user[window._env_.REACT_APP_OIDC_TOKEN]};
            }
        }

        return fetch(url, requestOptions)
            .then(async response => {
                if (!response.ok) {
                    const error = await response.json();
                    throw Error(JSON.stringify(error));
                }
                if (response.status === 204) {
                    return null;
                }
                return response.json();
            });
    });
}

// Job CRUD operations
export const getJobs = createAsyncThunk("request/getJobs", async ({userManager}) => {
    const response = await cockpitAPIcall({
        url: `${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs`,
        requestOptions: {method: "GET", headers: {"content-type": "application/json"}},
        userManager
    });
    return response;
});

export const createJob = createAsyncThunk("request/createJob", async ({name, datasource, model, userManager}) => {
    const body = {name, datasource, model};
    const response = await cockpitAPIcall({
        url: `${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs`,
        requestOptions: {
            method: "POST",
            headers: {"content-type": "application/json"},
            body: JSON.stringify(body)
        },
        userManager
    });
    return response;
});

export const updateJob = createAsyncThunk("request/updateJob", async ({id, name, datasource, model, userManager}) => {
    const body = {name, datasource, model};
    const response = await cockpitAPIcall({
        url: `${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs/${id}`,
        requestOptions: {
            method: "PUT",
            headers: {"content-type": "application/json"},
            body: JSON.stringify(body)
        },
        userManager
    });
    return response;
});

export const deleteJob = createAsyncThunk("request/deleteJob", async ({id, userManager}) => {
    await cockpitAPIcall({
        url: `${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs/${id}`,
        requestOptions: {method: "DELETE", headers: {"content-type": "application/json"}},
        userManager
    });
    return id;
});

export const startJobRun = createAsyncThunk("request/startJobRun", async ({jobId, userManager}) => {
    const response = await cockpitAPIcall({
        url: `${window._env_.REACT_APP_STARTJOB_URL}/v1/jobs/${jobId}/jobRuns`,
        requestOptions: {method: "POST", headers: {"content-type": "application/json"}},
        userManager
    });
    return response;
});
